/**
 * Figma design-token colors for the Funding dashboard (node 359:30305).
 * A few of these (slate `#62748e` / `#0f172b`, series indigo `#6366f1`) have no
 * matching token in @labrav/react-components yet; centralized here so the whole
 * dashboard swaps to palette tokens in one place once they exist.
 *
 * TODO: replace these local hex values with shared palette tokens once
 * @labrav/react-components adds the missing slate / series colors. Until then
 * this file is the single override point — do not hardcode these hexes inline.
 */
export const fundingColors = {
  cardBg: '#ffffff',
  metricBg: '#f6f7f9',
  metricBorder: '#e2e8f0',
  metricShadow: '0px 0px 2px rgba(0,0,0,0.12)',
  iconBoxBg: '#eff1f1',
  darkText: '#2e3132',
  valueText: '#0f172b',
  labelText: '#62748e',
  mutedText: '#6a777a',
  divider: '#e2e2e2',
  separator: '#e2e8f0',
  todoPillBorder: '#ff708a',
  // Status pills, LeadFinder Figma (G5wW4gbozMKTOs1PmxcdnM, node 1:1275).
  approvedPillBg: '#dcfce7',
  approvedPillText: '#15803d',
  pendingPillBg: '#fef9c3',
  pendingPillText: '#854d0e',
  potentialPillBg: '#e0f2fe',
  potentialPillText: '#0369a1',
  todoButtonBg: '#eceeef',
  seriesConsumed: '#6366f1',
  seriesAvailable: '#00820d',
  seriesExtra: '#ff9b47',
  seriesTotal: '#e2e2e2',
  warningBg: '#ffdfc6',
  strongText: '#212121',
  linkBlue: '#1942c5',
  buttonBorder: '#bfc8ca',
  reviewBorder: '#dddddd',
  successText: '#00820d',
  successBadgeBg: '#c9efcd',
  negBadgeText: '#c55b02',
  stepCurrent: '#048297',
  stepUpcomingBorder: '#b0bdc2',
  timelineLine: '#e8e8e8',
  dangerDot: '#ba1a1a',
  bannerBorder: '#ff9b47',
  programCardBg: '#f8f9fa',
  eligiblePillBg: '#e1f0f3',
  scrollHintBg: '#f2f3f5',
  scrollHintBorder: '#e2e4e8',
  tooltipLink: '#ff9b47',
} as const
